import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "d-flex justify-center" }
const _hoisted_5 = { class: "d-flex align-center" }
const _hoisted_6 = { class: "pa-7" }
const _hoisted_7 = {
  class: "text-center pr-5",
  style: {"width":"40px"}
}
const _hoisted_8 = { class: "caption" }
const _hoisted_9 = { class: "text-no-wrap" }
const _hoisted_10 = { style: {"white-space":"pre-wrap","user-select":"none"} }
const _hoisted_11 = { style: {"line-height":"38px"} }
const _hoisted_12 = { class: "icon mr-2" }
const _hoisted_13 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_calendar = _resolveComponent("v-calendar")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_scroll = _resolveDirective("scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      tile: "",
      class: "overflow-hidden no-scroll-bar",
      elevation: "0",
      style: {"background-color":"transparent"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_app_bar, {
          class: "app_bar",
          fixed: "",
          color: "primary",
          dark: "",
          "scroll-target": "#scrolling-techniques-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _ctx.toPrevMonth,
              icon: "",
              class: "no-background-hover",
              color: "white",
              dark: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_icon, {
                    size: "20",
                    class: "ml-4"
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("mdi-chevron-left", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "white--text" }, "前の月", -1))
                ])
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_app_bar_title, null, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCalendar = !_ctx.isCalendar))
                }, [
                  _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.year) + "年 ", 1),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.month), 1),
                    (_ctx.isCalendar)
                      ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("mdi-chevron-down", -1)
                          ]))]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("mdi-chevron-up", -1)
                          ]))]),
                          _: 1
                        }))
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              onClick: _ctx.toNextMonth,
              icon: "",
              class: "no-background-hover",
              color: "white"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "white--text" }, "次の月", -1)),
                  _createVNode(_component_v_icon, {
                    size: "20",
                    class: "mr-4"
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("mdi-chevron-right", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_expand_transition, null, {
          default: _withCtx(() => [
            (_ctx.isCalendar)
              ? (_openBlock(), _createBlock(_component_v_sheet, {
                  key: 0,
                  class: "mt-8",
                  height: "400",
                  style: {"background-color":"transparent"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_calendar, {
                      ref: "event_calendar",
                      now: _ctx.now,
                      modelValue: _ctx.selectedDate,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDate) = $event)),
                      color: "primary",
                      locale: "ja-jp",
                      "day-format": timestamp => new Date(timestamp.date).getDate(),
                      "month-format": timestamp => (new Date(timestamp.date).getMonth() + 1) + ' /',
                      "onClick:date": _ctx.viewDay
                    }, {
                      day: _withCtx(({ date }) => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getEventNum(date), (e) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: e.eventId,
                            class: "d-flex justify-center"
                          }, [...(_cache[8] || (_cache[8] = [
                            _createElementVNode("div", { class: "event_num ma-1" }, null, -1)
                          ]))]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["now", "modelValue", "day-format", "month-format", "onClick:date"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [
          [_vShow, !_ctx.isCalendar]
        ]),
        _createVNode(_component_v_sheet, {
          id: "scrolling-techniques-2",
          class: "overflow-y-auto no-scroll-bar",
          style: {
          maxHeight: `calc(100vh - var(--app-top-offset) - 60px)`,
          backgroundColor: 'transparent'
        },
          elevation: "0"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (e, index) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                key: e + index,
                class: "plan-wrapper ma-1 pa-2 px-3 d-flex"
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.dayFormat(e.date)), 1),
                  _createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.dateFormat(e.date)), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", _hoisted_11, _toDisplayString(e.eventName), 1)
                ]),
                _createVNode(_component_v_spacer),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(e.children, (child) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: child.childId
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("img", {
                        src: child.imageUrl? child.imageUrl : 'https://via.placeholder.com/240x180?text=Sample+Image+1'
                      }, null, 8, _hoisted_13)
                    ])
                  ]))
                }), 128))
              ])), [
                [_directive_scroll, _ctx.onScroll, "#scrolling-techniques-2"]
              ])
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}